export const NAME_REDUCER = 'receipt';

export const PREFIX_ACTIONS = 'receipt_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
